import axios from 'axios'
import swal from 'sweetalert2'
import * as qs from "qs";
import { getToken, clearToken } from './tokenService';
import { aplicarRenovacion, CABECERA_DE_RENOVACION, CABECERA_DE_SESION, esApertura, esperarApertura, esSesionInvalida, obtenerSesion, terminarSesionInvalida } from './sesionPortal';
// import {useLoadingDispatch} from "../layout/show-loading-context";

//el service factory mandará por default el loading en los post y put, y no mostrará loading en gets
//si se desea cambiar esto, se debe enviar en el config la variable showLoading;
//ejemplo para get:   async (params) => service.get(`/operaciones/comercial/cotizaciones`, {params, showLoading:true}),
//ejemplo para post:  async (params) => service.post(`operaciones/comercial/cotizaciones`, params, {showLoading:false}),

export interface IApiOptions {
  headers?: {
    "Content-Type" : "string",
    "Accept" : "string",
    "Ocp-Apim-Subscription-Key" : "string"
}
    uri?: string
    timeout?: number
}

function useServiceFactory(options: IApiOptions = {}) {

    // const dispatch = useLoadingDispatch();
    const headers = options.headers || {"Content-Type" : "application/json",
                                         "Accept" : "text/plain",
                                         "Ocp-Apim-Subscription-Key" : process.env.REACT_APP_API_SUBSCRIPTION_KEY || ""};
    const baseUrl =(options && options.uri) || process.env.REACT_APP_API_URL;
  
    const isMockServer = baseUrl == null || baseUrl.includes('http://localhost:3001');

    const service = axios.create({
        baseURL: baseUrl,
        timeout: (options && options.timeout) || 150000,
        headers,
        
        withCredentials: false
    });

    // const showLoading = (config) => {
    //     if ( (config.showLoading?? config.method !== 'get') !== true )
    //         return;
    //
    //     dispatch({type: 'show'});
    // };
    //
    // const hideLoading = (config) =>{
    //     if ( config!= null &&  (config.showLoading?? config.method !== 'get') !== true )
    //         return;
    //
    //     dispatch({type: 'hide'});
    // };

   service.interceptors.request.use(async function (config) {

        // Do something before request is sent
        config.paramsSerializer= (params) => {
            return qs.stringify(params)
        };
        // showLoading(config);

        try {
            if (!esApertura(config.url)) {
                await esperarApertura();
            }

            const token = await getToken();
            config.headers['Authorization'] = `Bearer ${token}`;

            const sesion = obtenerSesion();
            const tokenPortal = sessionStorage.getItem("token");

            if (sesion) {
                config.headers[CABECERA_DE_SESION] = sesion;
            } else if (tokenPortal) {
                config.headers['X-Portal-Token'] = tokenPortal;
            }
        } catch (e) {
            // No continuar sin token - rechazar la petición
            return Promise.reject(e);
        }

        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });


    service.interceptors.response.use(
        (res) => {
            aplicarRenovacion(res.headers?.[CABECERA_DE_RENOVACION]);

            // hideLoading(res.config);

            if (res.data.timeGenerated != null)
                return res.data.result;
            return res.data;
        },
        async (error) => {

        
            // hideLoading(error.response?.config);
            if (error.response) {
                aplicarRenovacion(error.response.headers?.[CABECERA_DE_RENOVACION]);
            }

            if (esSesionInvalida(error.response)) {
                terminarSesionInvalida();
                return Promise.reject(error);
            }

            if (error.response) {
                switch (error.response.status) {
                    case 400:
                       /* await swal.fire({
                            titleText: 'Atención.',
                            text: error.response.data.ErrorMessage,
                            type: 'warning',
                        });*/
                        return Promise.reject(error);
                    case 401:
                         clearToken();
                        if (!error.config._retry) {
                            error.config._retry = true;
                            try {
                                const newToken = await getToken();
                                error.config.headers['Authorization'] = `Bearer ${newToken}`;
                                return service.request(error.config);
                            } catch (tokenError) {
                                return Promise.reject(tokenError);
                            }
                        }
                        return Promise.reject(error);
                    case 403:
                       
                     /*  await swal.fire({
                            titleText:  '¡Error!',
                            text: error.response.message,
                            type: 'error',
                        });*/
                        return Promise.reject(error.response);
                    case 404:
                    case 422:
                    case 500:
                    case 502:
                    default:
                        if (isMockServer)
                            return;
                      /*  await swal.fire({
                            titleText: 'Lo sentimos, se produjo un error inesperado. Si el problema persiste, comuníquese con el administrador de sistema.',
                            text: error.response.data.message,
                            type: 'warning',
                        });*/
                        return Promise.reject(error)
                }
            }
            return Promise.reject(error)
        }
    );

    return service
}

export default useServiceFactory;
